/** Default chat panel height for agent hub pages. */
export const HUB_CHAT_PANEL_HEIGHT = {
  xs: 480,
  md: "min(70vh, 720px)",
} as const;
